import { PrimaryButton, QuantityCounter, Space, Text } from '@procurify/ui'

import { Price } from '@webapp/core/components/Price'
import { type CurrencyName } from '@webapp/core/entities/external/Currency/CurrencyName'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { CatalogItemDeliveryLabel } from '../CatalogItemDeliveryLabel'
import { CatalogItemDetailsCartActionsStyled } from './styles/CatalogItemDetailsCartActionsStyled'
import { CatalogItemDetailsCartTotalStyled } from './styles/CatalogItemDetailsCartTotalStyled'
import { type ConversationCatalogItemDelivery } from '../../value-objects/ConversationTurnItem'

export interface ICatalogItemDetailsCartProps {
  quantity: number
  estimatedTotal: number
  currency: CurrencyName
  delivery?: ConversationCatalogItemDelivery
  onQuantityChange: (quantity: number) => void
  onAddToRequest: () => void
}

export const CatalogItemDetailsCart = ({
  quantity,
  estimatedTotal,
  currency,
  delivery,
  onQuantityChange,
  onAddToRequest,
}: ICatalogItemDetailsCartProps) => {
  const intl = useProcurifyIntl()

  return (
    <Space direction='vertical' size='medium'>
      <Space direction='vertical' size='xsmall'>
        <Space direction='horizontal' justify='space-between' align='center'>
          <Text>{intl.formatMessage(messages.estimatedTotal)}</Text>
          <CatalogItemDetailsCartTotalStyled className='fs-mask'>
            <Price inline price={estimatedTotal} currency={currency} />
          </CatalogItemDetailsCartTotalStyled>
        </Space>
        {delivery && <CatalogItemDeliveryLabel delivery={delivery} />}
      </Space>
      <CatalogItemDetailsCartActionsStyled>
        <QuantityCounter
          isValueEditable
          value={quantity}
          onChange={onQuantityChange}
          aria-label={intl.formatMessage(messages.quantityAriaLabel)}
        />
        <PrimaryButton
          fullWidth
          analyticsId='catalog-item-details-add-to-request-button'
          onClick={onAddToRequest}
        >
          {intl.formatMessage(messages.addToRequestButton)}
        </PrimaryButton>
      </CatalogItemDetailsCartActionsStyled>
    </Space>
  )
}
